// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__fc1S6","hoverable":"card_hoverable__deHdu"};